import React from 'react';
import PropTypes from 'prop-types';
import { CreateTypes } from '../../';
import { connect } from 'react-redux';
import { Panel, Row, Col, Alert} from 'react-bootstrap';
import * as Actions from 'actions';
import * as Permissions from 'permissions';

class TypeSettings extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'TypeSettings';
    this.state = {}
  }
  colorClasses = [ 'primary', 'secondary', 'tertiary', 'quartenary', 'success', 'danger', 'warning', 'info', 'dark']
  render() {
    if(!this.props.hasPermission(Permissions.UPDATE_TYPE_SETTINGS)) {
      return <Alert bsStyle='warning'>
        <h4>Sorry! Insufficient Permissions.</h4>
        <p>You must have gotten here in error, because you do not have permission to change these settings.</p>
        <p>Contact your administrator if this makes no sense.</p>
      </Alert>
    }

    return(
      <Row>
        <Col xs={12} sm={6} md={4}>
          <div className="panel panel-transparent">
            <div className="panel-heading">
              <h3 className="panel-title">Opportunities</h3>
              <div className="panel-subtitle">The custom types for opportunities.</div>
            </div>
            <div className="panel-body">
              <Row>
                <Col xs={12}>
                  <Panel bsStyle='tertiary' header={<h3 className="panel-title">Opportunity Source</h3>}>
                      <CreateTypes entity="job" field="lead_source" />
                  </Panel>
                  <Panel bsStyle='tertiary' header={<h3 className="panel-title">Opportunity Category</h3>}>
                      <CreateTypes entity="job" field="category" />
                  </Panel>
                  <Panel bsStyle='tertiary' header={<h3 className="panel-title">Opportunity Work Type</h3>}>
                      <CreateTypes entity="job" field="work_type" />
                  </Panel>
                  <Panel bsStyle='tertiary' header={<h3 className="panel-title">Opportunity Trade</h3>}>
                      <CreateTypes entity="job" field="trade" />
                  </Panel>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} md={4}>

        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, Actions)(TypeSettings);



// WEBPACK FOOTER //
// ./src/browser/components/clients/settings/type-settings.js